import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { schedaCoopAgricoleRules } from './scheda-coop-agricole.rules';

export const SchedaCoopAgricoleRules: FormGroupRules = {
    ...schedaCoopAgricoleRules,
};

export const SchedaCoopAgricoleFormValidators = [...Object.values(SchedaCoopAgricoleRules)];
